import { Injectable } from '@angular/core';
import { AuthServerProvider } from 'app/core/auth/auth-jwt.service';
import {AccountService} from '../../singelton/account.service';
import {Router} from '@angular/router';

@Injectable({ providedIn: 'root' })
export class LoginService {
  constructor(private accountService: AccountService,
              private authServerProvider: AuthServerProvider,
              private router:Router ) {}

  login(credentials, callback?) {
    const cb = callback || function() {};

    return new Promise((resolve, reject) => {
      // Drop any leftover token before login so a stale JWT cannot interfere
      this.authServerProvider.clearAuthenticationToken();
      this.accountService.authenticate(null);

      this.authServerProvider.login(credentials).subscribe(
        data => {
          this.accountService.identity(true).then(() => {
            resolve(data);
          });
          return cb();
        },
        err => {
          this.authServerProvider.clearAuthenticationToken();
          this.accountService.authenticate(null);
          reject(err);
          return cb(err);
        }
      );
    });
  }

  // loginWithToken(jwt, rememberMe) {
  //   return this.authServerProvider.loginWithToken(jwt, rememberMe);
  // }

  // logout() {
  //   this.accountService.clearPath(this.accountService.getWebSocketUUID()).subscribe(
  //     next=>{
  //
  //       this.authServerProvider.logout().subscribe(null, null, () => {
  //         this.accountService.authenticate(null);
  //         this.router.navigate(['/authentication/login']);
  //       })},
  //     error=>{
  //
  //       this.authServerProvider.logout().subscribe(null, null, () => {
  //         this.accountService.authenticate(null);
  //         this.router.navigate(['/authentication/login']);
  //       }); } )
  //
  // }


  logout() {
    this.authServerProvider.logout().subscribe(null, null, () => {
      this.accountService.authenticate(null);
      this.router.navigate(['/authentication/login']);
    });
  }
}
